//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import includes from 'lodash/includes';
export default {
  props: {
    elements: {
      type: Array,
      required: true
    },
    matches: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    // TODO: These fields are not shown in any way (same behaviour as old CORGA and TILG)
    moreElementsBefore: {
      type: Boolean,
      "default": false
    },
    moreElementsAfter: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      // Used to locate index of row in the matrix for a given tag.
      // Since this list does not change, it's calculated here only once.
      tagList: this.$ncsConfig.tags.matrix.map(function (r) {
        return r.join('');
      })
    };
  },
  methods: {
    isMatch: function isMatch(e) {
      return includes(this.matches, e.search_index);
    }
  }
};